//this is store of data which will be there util logout happens 
import create, { SetState, StateCreator, StoreApi } from 'zustand'

interface DurableStore {
    filterDropdowns: any,
    setFilterDropdowns :(x:any) => void,
    scoreData: { [key: string]: any },
    setScoreData :(x:any) => void,
    structureData: { [key: string]: any },
    setStructureData :(x:any) => void,
    clearStore: () => void,
}


let store:
  | StateCreator<DurableStore, [], [], DurableStore>
  | StoreApi<DurableStore> = (set: SetState<DurableStore>) => ({
  filterDropdowns: {},
  setFilterDropdowns : (x) => {
    set((state) => ({ filterDropdowns: {...state.filterDropdowns , ...x} }));
  },
  scoreData: {},
  setScoreData : (x) => {
    set((state) => ({ scoreData: {...state.scoreData   , ...x} }));
  },
  structureData : {},
  setStructureData : (x) => {
    set((state) => ({ structureData: {...state.structureData   , ...x} }));
  },
  clearStore: () => {
    set(() => ({ filterDropdowns : {} }));
    set(() => ({ scoreData : {} }));
    set(() => ({ structureData : {} }));
  },
});


export const useDurableStore  = create(store)